import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  Sign: '',
  SignOfTemplate: '',
  nameOfSignature: '',
  sessionDataID: '',
  clientSign: '',
  clientSignName: '',
};

const Cosignature = createSlice({
  name: 'Cosignature',
  initialState,
  reducers: {
    signData: (state, action) => {
      state.Sign = action.payload;
    },
    signDataTemplate: (state, action) => {
      state.SignOfTemplate = action.payload;
    },
    clearSignatueTemplate: state => {
      state.SignOfTemplate = '';
    },
    signDataName: (state, action) => {
      state.nameOfSignature = action.payload;
    },
    signDataSessionID: (state, action) => {
      state.sessionDataID = action.payload;
    },
    clientSign: (state, action) => {
      state.clientSign = action.payload;
    },
    clientSignName: (state, action) => {
      state.clientSignName = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  clearSignatueTemplate,
  signData,
  signDataTemplate,
  signDataName,
  signDataSessionID,
  clientSign,
  clientSignName,
} = Cosignature.actions;

export default Cosignature.reducer;
